/*
<div xms-tree
    ng-model="formModel.treeCheckboxes"
    data="formModel.treeData"
    options="{selectAll:true, deselectAll:true}">
    <div ivh-treeview="data"></div>
        <!-- ivh-treeview-node-tpl="template"></div>-->
</div>

Please mind it shows poor performance for bigger trees (over 1000 nodes).
This is not yet finished - it won't accept validation-messages for some reason
*/

(function() {
    'use strict';

// the first directive is purely for DOM manipulation on pre-transcluded content !!!!!
// (it's only for validation - it needs to be done this way otherways the form will not pick up new element before xms-validation kicks on)
var xmsTreePre = function(){
    // Return the directive configuration. Notice that we are running at
    // a higher priority than the next directive binding.
    return({
        compile: compile,
        priority: 10, // mind the priority here!
        restrict: "EA"
    });
    // I compile the pre-transcluded content.
    function compile( tElement, tAttributes ) {
        if( !angular.isDefined(tAttributes.name) ) {
            throw 'Please define xmsTree hidden field name attribute.';
        }
        angular.element(tElement).append('<input style="display:none" type="text" name="'+tAttributes.name+'" ng-model="ngModel" required />');
    }
};
angular.module('app').directive('xmsTree', xmsTreePre);




var xmsTree = function($timeout, $compile, ajaxCall, formFieldFactory, ivhTreeviewMgr, ivhTreeviewBfs) {
    return {
        restrict: 'EA',
        priority: 1,
        replace: true,
        scope: true,
        bindToController: {
            ngModel: '=',
            src: "=", // url or data array
            options: '&',
            name: '@'
        },
        controllerAs: 'ctrl',
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

        	var _this = this;
            $scope.loading = false;

        	/* $scope.template = [
			    '<div>',
			      '<span ivh-treeview-toggle>',
			        '<span ivh-treeview-twistie></span>',
			      '</span>',
			      '<ascii-box></ascii-box>',
			      '<span class="ivh-treeview-node-label" ivh-treeview-toggle>',
			       '{{:: trvw.label(node)}}',
			      '</span>',
			      '<div ivh-treeview-children ng-if="trvw.isExpanded(node)"></div>',
			    '</div>'
			].join('\n'); */



        	var i=0; // tmp

            _this.$onInit = function(){

                if(!angular.isDefined(this.ngModel)){
                    this.ngModel = '';
                    $scope.ngModel = '';
                }

                if(angular.isArray(_this.src)) { // TODO isObject?
                    $scope.treeData = this.src;
                } else { // url - load data
                    $scope.loading = true;
                    ajaxCall.getData(_this.src).then(
                        function(result) {
                            var ajaxData = result.data;

                            if( angular.isDefined($attrs.transformDynatreeJson) ){
                                if(!angular.isArray(ajaxData)) { // sometimes dynatree json is returned as a root object not array
                                    ajaxData = [ajaxData];
                                }
                                iterate(ajaxData);
                                console.log('!!!!!!!!!!!!!: '+i); // element count - tmp
                            }

                            $scope.treeData = ajaxData;
                            $scope.loading = false;
                        },
                        function(result) {
                            console.log('error occured');
                            console.log(result);
                        }
                    );
                }
            }

            // this two functions are done only for old data compliance - they should be removed as soon as right json is provided
            function iterate(data){
            	angular.forEach(data, function(obj){
            		for (var property in obj) {
			            if (obj.hasOwnProperty(property)) {
			            	if(typeof obj[property] && property=='children') {
			            		console.log(typeof obj[property] + ' ' + property);
			            		iterate(obj[property]);
			            	}
			            }
			        }
			        transformDynatreeJsonNode(obj);
            	});
            }
            function transformDynatreeJsonNode(node){
                if(angular.isObject(node)){
            		node.id 		= node.key;
            		node.selected 	= node.select;
            		node.label 		= node.title;
    				delete node.key;
    				delete node.select;
    				delete node.title;
    				i++;
                }
        	}


        	// update ngModel
            $scope.$watch(function($scope){
            	return $scope.treeData;
            }, function(newVal, oldVal){
            	if(newVal!==oldVal){

                    var IDs = new Array();

                    angular.forEach( returnSelected(newVal), function(node){
                        IDs.push(node.id);
                    });

                    _this.ngModel = IDs.join(',');

                    // only when our model is changed
                    if( angular.isDefined($attrs.xmsValidation) && angular.isDefined($attrs.required) ) {
                        if(_this.ngModel != $scope.ngModel){ // otherwise triggered on each $treeData update....
                            // TODO: name!!
                            $scope.ngModel = _this.ngModel; // needed for validation input - for some magical reason it won't pick up ctrl.ngModel!!!
                            if(angular.isDefined( $scope.form[_this.name]) ){
                                formFieldFactory.triggerDependantFieldValidation($scope.form[_this.name]);
                            }
                        }
                    }
            	}
            }, true);
            // find all checked nodes
            function returnSelected(treeData){
            	var selectedNodes = [];
            	ivhTreeviewBfs(treeData, function(node) {
            		if(node.selected === true){
            			selectedNodes.push(node);
            		}
			    });
			    return selectedNodes;
            }
        }],
        transclude: true,
        require: 'xmsTree',
        link: {
            pre: function (scope, elem, attrs, ctrl, transclude) {

                console.log('xmsTree');


                // elem.append( $compile('<input type="text" name="treeValidationInput" ng-model="ngModel" required />')(scope) );


                scope.ivhTreeviewMgr = ivhTreeviewMgr;

                //$timeout(function(){
                //    elem.append( '<div nf-if="false"><input type="text" name="treeValidation" ng-model="ctrl.ngModel" xms-validation required validation-messages="{required:\'At least one selection is required.\'}" /></div>' );
                //});

                elem.addClass('xms-tree-box')
                    .prepend('<div class="form-box"></div>');
                var formBox = elem.find('.form-box');

                (function transcludeAndBootstrap(){

                    transclude(scope, function(transEl) {
                        formBox.append(transEl);
                    }); // also linking transcluded content happens here

                    // add loading spinner
                    formBox.prepend( $compile('<div style="text-align:center" ng-if="loading"><i class="loading-spinner">Loading...</i></div>')(scope) );

                    if(angular.isDefined(ctrl.options())){
                        if(ctrl.options().selectAll) {
                            formBox.append( $compile('<a class="xms-tree-option" href="javascript:void(0);" ng-click="ivhTreeviewMgr.selectAll(treeData)">Select All</a>')(scope));
                        }
                        if(ctrl.options().deselectAll) {
                            formBox.append( $compile('<a class="xms-tree-option" href="javascript:void(0);" ng-click="ivhTreeviewMgr.deselectAll(treeData)">Unselect All</a>')(scope));
                        }
                    }

                    // add filtering
                    var filterModel = elem.find('[ivh-treeview]').attr('ivh-treeview-filter');
                    if( angular.isDefined(filterModel) ){
                        formBox.prepend( $compile('<input type="text" class="form-control xms-tree-filter" placeholder="Filter" ng-model="'+filterModel+'" />')(scope.$parent) );
                    }

                })(); // execute on init

                //$timeout(function(){
                //    formBox.append( $compile('<div ng-if="!loading"><pre>{{ctrl.ngModel | json}}</pre><input type="text" name="treeValidationInput" ng-model="ngModel" xms-validation required validation-messages="{required:\'At least one selection is required.\'}" /></div>')(scope) );
                //});
            }
        }

    };
}
xmsTree.$inject = ['$timeout', '$compile', 'ajaxCall', 'formFieldFactory', 'ivhTreeviewMgr', 'ivhTreeviewBfs'];
angular.module('app').directive('xmsTree', xmsTree);




/*
app.directive('asciiBox', function(ivhTreeviewMgr) {
    return {
        restrict: 'AE',
        template: [
            '<span class="ascii-box">[',
                '<span ng-show="node.selected" class="x" ng-click="trvw.select(node, false)">x</span>',
                '<span ng-show="node.__ivhTreeviewIndeterminate" class="y" ng-click="trvw.select(node)">~</span>',
                '<span ng-hide="node.selected || node.__ivhTreeviewIndeterminate" ng-click="trvw.select(node)"> </span>',
            ']</span>',
        ].join(''),
        link: function(scope, element, attrs) {
            console.log('ascii-box');
            console.log(scope);
            //element.on('click', function() {
            //  console.log(scope);
            //  ivhTreeviewMgr.select(scope.$parent.$parent.$parent.ctrl.data, scope.node, !scope.node.selected);
            //  scope.$apply();
            //});
        }
    };
});*/

}());

